module.exports = __webpack_public_path__ + "static/media/language.4bcfb0c4.svg";